import { render } from "./Receipts.vue?vue&type=template&id=1c105ad3&scoped=true"
import script from "./Receipts.vue?vue&type=script&lang=js"
export * from "./Receipts.vue?vue&type=script&lang=js"

import "./Receipts.vue?vue&type=style&index=0&id=1c105ad3&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c105ad3"]])

export default __exports__